import React, { useState } from 'react'
import { MdClose } from 'react-icons/md'
import "./Search.css";
import back from "./images/back.jpg"
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';

function Search({setShowSearch}: any) {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const onChange = (e: any) => {
    setQuery(toTitleCase(e.target.value))
  }
  function toTitleCase(str: any) {
    return str.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  let {data} = useFetch(`/api/products?populate=*&filters[title][$contains]=${query}`);

  if(!query.length){
    data = null;
  }
  return (
    <div className='search-modal'>
    <img className='back' src={back} alt="" />
      <div className="form-field">
        <input type="text" autoFocus placeholder='Search for Products' value={query} onChange={onChange}/>
        <MdClose style={{color: "white"}} onClick={() => setShowSearch(false)}/>
      </div>
      <div className="search-result-content">
        <div className="search-results">
          {data?.data?.map((item) => (
            <div key={item.id} className="search-result-item" onClick={() => {
              navigate("/product/" + item.id);
              setShowSearch(false);
            }}>
                <div className="search-item-img">
                    <img src={item?.attributes?.img?.data[0]?.attributes?.url} alt="" />
                </div>
                <div className="cart-item-details">
                    <span className="cart-item-name" style={{color: "#838383"}}>{item.attributes.title}</span>
                    <span className="cart-item-desc">{item.attributes.desc}</span>
                </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Search
